import React from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'
import { Avatar, If, List, Text } from 'src/Components'
import Phone from 'src/Components/shared/Phone'
import Email from 'src/Components/shared/Email'
import NMLS from 'src/Components/shared/NMLS'

import styles from './Intro.module.scss'

const propTypes = {
  loading: PropTypes.bool,
  toName: PropTypes.string,
  customerName: PropTypes.string.isRequired,
  photoUri: PropTypes.string.isRequired,
  email: PropTypes.string,
  nmls: PropTypes.string,
  phone: PropTypes.string,
  companyName: PropTypes.string
}

const Intro = ({
  toName,
  customerName,
  companyName,
  phone,
  photoUri,
  email,
  nmls,
  loading,
  children
}) => (
  <div
    className={classnames(styles.intro, loading && styles.loading)}
    data-qa='Intro'
  >
    <Avatar className={styles.avatar} src={photoUri} />
    <div className={styles.introExplain}>
      <Text className={styles.explain}>
        <If condition={toName}>
          <FormattedMessage
            id='Intro.salutation'
            defaultMessage='Hi {firstName}!'
            values={{ firstName: toName }}
          />{' '}
        </If>
        {children}
      </Text>
      <Text element='div' color='quiet'>
        <List.Bulleted.Inline className={styles.contact}>
          {customerName}
          {companyName}
        </List.Bulleted.Inline>

        <List.Bulleted.Inline className={styles.contact}>
          <Phone value={phone} />
          <Email value={email} />
          {nmls && nmls.length && <NMLS value={nmls} />}
        </List.Bulleted.Inline>
      </Text>
    </div>
  </div>
)

Intro.propTypes = propTypes

export default Intro
